import React from 'react'
import styles from './ClimbViewer.scss'
import { BlockLoading } from 'common/BlockLoading'
import { ClimbAnimation } from 'common/ClimbAnimation'
import blockSizes from '../../../App/blockSizes.scss'
import cx from 'classnames'
import { connect } from 'react-redux'
import _ from 'lodash'
import { validatedHighlightSlice } from 'lib/reportUtils'
import { SingleLineEditor } from 'common/SingleLineEditor'

// We're starting to accumulate a lot of code duplication between viewers and blocks.
export class ClimbViewer extends React.Component {
  constructor (props) {
    super(props)
    this.state = { paused: true }
    this._throttledOnScroll = _.throttle(this.onScroll, 100) // throttle scroll position check to 10Hz
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this._throttledOnScroll)
    this.onScroll()
  }

  onScroll = (e) => {
    if (!this._blockRef) { return }
    const rect = this._blockRef.getBoundingClientRect()

    if (rect.top < 50 || rect.bottom > (window.innerHeight - 100)) {
      !this.state.paused && this.pause()
    } else {
      this.state.paused && this.play()
    }
  }

  pause = () => {
    this.setState({ paused: true })
  }

  play = () => {
    this.setState({ paused: false })
  }

  onClimbSelected = ({ rideId, highlightSlice }) => {
    this.props.blockProps.onChange({ rideId, highlightSlice })
  }

  setBlockRef = (ref) => {
    this._blockRef = ref
  }

  render () {
    const { block, ride } = this.props
    const { metricUnits } = this.props.blockProps
    const { paused } = this.state
    const data = block.getData()
    const caption = data.get('caption')
    const rideId = data.get('rideId')
    const highlightSlice = validatedHighlightSlice(data, ride)

    // no ride ID means we for sure don't want to display
    if (!rideId) {
      return null
    }
    if (!ride) {
      return (
        <div ref={this.setBlockRef}>
          <BlockLoading height={200}>Loading...</BlockLoading>
        </div>
      )
    }
    // if we get here, it means we have a ride but no valid highlight slice
    if (!highlightSlice) {
      return null
    }
    const trackPoints = ride.rawPoints

    return (
      <div ref={this.setBlockRef} className={cx(styles.ClimbViewer, blockSizes.normalBlock)}>
        <ClimbAnimation metricUnits={metricUnits} trackPoints={trackPoints} paused={paused} highlightSlice={highlightSlice} />
        {caption && <figcaption className={styles.caption}>
          <SingleLineEditor
            defaultValue={caption}
            textAlignment='center'
            readOnly
            type='caption'
          />
        </figcaption>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ride: state.trips.get(ownProps.block.getData().get('rideId'))
})

export const ClimbViewerContainer = connect(
  mapStateToProps,
  null
)(ClimbViewer)
